import React from 'react';
import './ErrorModal.css';

export default function ErrorModal({ message, onClose }) {
  if (!message) return null; // Ne rien afficher si pas d'erreur

  return (
    <div className="error-overlay">
      <div className="error-modal">
        <h2>Une erreur est survenue</h2>
        <p>{message}</p>
        <button onClick={onClose}>Fermer</button>
      </div>
    </div>
  );
}
